module.exports = __webpack_public_path__ + "static/img/large_pores-01.7bf510b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/large_pores-01.jpg
// module id = 273
// module chunks = 1